import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import Button from '../atoms/Button';

const FooterButtons = ({ buttonIconSucess, buttonTextCancel, buttonTextSucess, loading, onSuccess, onCancel, disabledSuccess, className }) => {
  return (
    <div className={clsx('footer-buttons', className)}>
      {onCancel && <Button type="reset" variant="inline" color="transparent" onClick={onCancel} text={buttonTextCancel} size="small" disabled={loading} />}
      {onSuccess && (
        <Button
          disabled={disabledSuccess || loading}
          icon={buttonIconSucess}
          loading={loading}
          onClick={onSuccess}
          size="small"
          text={buttonTextSucess}
          type="submit"
          variant="inline"
        />
      )}
    </div>
  );
};

FooterButtons.propTypes = {
  buttonIconSucess: PropTypes.string,
  buttonTextCancel: PropTypes.string,
  buttonTextSucess: PropTypes.string,
  loading: PropTypes.bool,
  onSuccess: PropTypes.func,
  onCancel: PropTypes.func,
  disabledSuccess: PropTypes.bool,
  className: PropTypes.string,
};

FooterButtons.defaultProps = {
  buttonTextCancel: 'Cancel',
  buttonTextSucess: 'Confirm',
  loading: false,
  typeButtonSuccess: '',
  disabledSuccess: false,
};

export default FooterButtons;
